<script lang="ts">
    import type { Snippet } from 'svelte';

    interface Props {
        children?: Snippet;
    }

    let { children }: Props = $props();
</script>

<div class="reptile-price">
    {@render children?.()}
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;

    .reptile-price {
        display: flex;
        gap: tokens.$oc-semantic-spacing-12;
        flex-direction: column;
        align-items: baseline;
        text-align: left;
        width: 100%;
    }
</style>
